/*
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2019-12-06 13:33:57
 * @LastEditors: sueRimn
 * @LastEditTime: 2019-12-06 15:08:31
 */
import axios from 'axios'
import {
  Toast
} from 'vant'

// 创建axios实例
const service = axios.create({
  baseURL: '/api', // api 的 base_url
  timeout: 5000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(resp => {
  return new Promise((resolve, reject) => {
    if (resp.status !== 200 || resp.data.error === 1) {
      reject(resp.data.msg)
    } else {
      resolve(resp.data)
    }
  })
}, error => {
  return new Promise((resolve, reject) => {
    reject(error)
  })
}
  // response => {
  //   const res = response.data
  //   if (response.status !== 200 || res.error === 1) {
  //     Toast.fail({
  //       message: res.msg,
  //       position: 'middle',
  //       duration: 5 * 1000
  //     })
  //     return Promise.reject('error')
  //   } else {
  //     return res
  //   }
  // },
  // error => {
  //   console.log('err' + error) // for debug
  //   Toast({
  //     message: error.message,
  //     position: 'middle',
  //     duration: 5 * 1000
  //   })
  //   return Promise.reject(error)
  // }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js